import { ROLE } from "@/providers/AuthorizationProvider/types";

export const NATIONAL_SECTION_LEGACY_ID = "PGA";
export const NATIONAL_SECTION_NAME = "National Section";

export const HQ_WIDE_ROLES = [ROLE.GLOBAL_ADMIN, ROLE.HQ_STAFF] as const;

export const DASHBOARD_SCHEDULE_MAX_PAGE_SIZE = 100;
export const DASHBOARD_PAST_EVENT_LIMIT = 5;

export const HOME_DASHBOARD_OVERVIEW_PATH = "/home" as const;
export const HOME_DASHBOARD_JOBS_PATH = "/home/jobs" as const;
export const HOME_DASHBOARD_MEMBERS_PATH = "/home/members" as const;
export const HOME_DASHBOARD_ASSOCIATES_PATH = "/home/associates" as const;
export const SECTION_ROSTER_DASHBOARD_PATH = "/home/roster" as const;
